import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Pencil, Trash2, Plus, Search } from "lucide-react";
import Select from "react-select";

export default function Customers() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [customername, setCustomername] = useState("");
  const [mobilenumber, setMobilenumber] = useState("");
  const [gstin, setGstin] = useState("");
  const [city, setCity] = useState("");
  const DEFAULT_STATE = "Tamil Nadu";
  const [state, setState] = useState(DEFAULT_STATE);
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [gelocation, setGeolocation] = useState("");
  const [website, setWebsite] = useState("");
  const [customerlist, setCustomerlist] = useState([]);
  const customerTypeOptions = [
    { label: "Wholesaler", value: "Wholesaler" },
    { label: "Retailer", value: "Retailer" }
  ];
  const [customertype, setCustomertype] = useState("");

  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);

  //Fetch Product
  useEffect(() => {
    fetCustomers();
  }, []);

  const fetCustomers = () => {
    console.log("http://tntyping.com/Adminconsole/api/nutscustomerlist");
    axios
      .get("http://tntyping.com/Adminconsole/api/nutscustomerlist")
      .then(function (response) {
        //console.log("Response:", response.data.result);
        if (response.data.errorCode === 2) {
          Swal.fire({
            icon: "error",
            text: response.data.Message,
            width: 320,
            padding: "1em",
            confirmButtonText: "OK",
            customClass: {
              popup: "rounded-xl text-sm"
            }
          });
        }

        if (response.data.errorCode === 0) {
          console.log("Response: ", response.data.result);
          setCustomerlist(response.data.result);
        }
      });
  };

  const onEdit = (item) => {
    setIsEditMode(true);
    setEditId(item.id);

    setCustomername(item.customername);
    setMobilenumber(item.mobilenumber);
    setGstin(item.gstin);
    setCity(item.city);
    setState(item.state);
    setEmail(item.email);
    setAddress(item.address);
    setGeolocation(item.gelocation);
    setWebsite(item.website);
    setCustomertype(item.type);

    setShowModal(true);
  };

  const handleSubmit = async () => {
    if (!customername) {
      Swal.fire({ icon: "warning", text: "Please enter customer name" });
      return;
    }

    if (!mobilenumber) {
      Swal.fire({ icon: "warning", text: "Please enter mobile number" });
      return;
    }

    if (!city) {
      Swal.fire({ icon: "warning", text: "Please enter city name" });
      return;
    }

    if (!state) {
      Swal.fire({ icon: "warning", text: "Please enter state name" });
      return;
    }

    if (!address) {
      Swal.fire({ icon: "warning", text: "Please enter address" });
      return;
    }

    if (!customertype) {
      Swal.fire({ icon: "warning", text: "Please select customer type" });
      return;
    }

    try {
      setLoading(true);

      let response;

      if (isEditMode) {
        // 🔥 EDIT API
        response = await axios.post(
          "http://tntyping.com/Adminconsole/api/" +
            "editcustomerbyid?id=" +
            editId +
            "&customername=" +
            customername +
            "&mobilenumber=" +
            mobilenumber +
            "&type=" +
            customertype +
            "&gstin=" +
            gstin +
            "&city=" +
            city +
            "&state=" +
            state +
            "&email=" +
            email +
            "&address=" +
            address +
            "&gelocation=" +
            gelocation +
            "&website=" +
            website
        );
      } else {
        // 🔥 ADD API
        response = await axios.post(
          "http://tntyping.com/Adminconsole/api/" +
            "nutscreatecustomers?customername=" +
            customername +
            "&mobilenumber=" +
            mobilenumber +
            "&type=" +
            customertype +
            "&gstin=" +
            gstin +
            "&city=" +
            city +
            "&state=" +
            state +
            "&email=" +
            email +
            "&address=" +
            address +
            "&gelocation=" +
            gelocation +
            "&website=" +
            website
        );
      }

      if (response.data.errorCode === 2) {
        Swal.fire({
          icon: "error",
          text: response.data.Message,
          width: 320,
          padding: "1em",
          confirmButtonText: "OK",
          customClass: {
            popup: "rounded-xl text-sm"
          }
        });
        return;
      }

      if (response.data.errorCode === 0) {
        Swal.fire({
          icon: "success",
          text: isEditMode
            ? "Customer Updated Successfully"
            : "Customer Added Successfully",
          timer: 1500,
          showConfirmButton: false,
          width: 320,
          padding: "1em",
          confirmButtonText: "OK",
          customClass: {
            popup: "rounded-xl text-sm"
          }
        });

        // Reset everything
        setShowModal(false);

        setIsEditMode(false);
        setEditId(null);

        setCustomername("");
        setMobilenumber("");
        setGstin("");
        setCity("");
        setState(DEFAULT_STATE);
        setEmail("");
        setAddress("");
        setGeolocation("");
        setWebsite("");
        setCustomertype("");

        fetCustomers();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: "Something went wrong. Please try again.",
        width: 320,
        padding: "1em",
        confirmButtonText: "OK",
        customClass: {
          popup: "rounded-xl text-sm"
        }
      });
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setIsEditMode(false);
    setEditId(null);

    setCustomername("");
    setMobilenumber("");
    setGstin("");
    setCity("");
    setState(DEFAULT_STATE);
    setEmail("");
    setAddress("");
    setGeolocation("");
    setWebsite("");
    setCustomertype("");
  };

  const onDelete = (item) => {
    Swal.fire({
      text: "Do you want to delete?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonText: "Yes",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6b7280",
      reverseButtons: true,
      width: 320,
      padding: "1em",
      customClass: {
        popup: "rounded-xl text-sm"
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.post(
            "http://tntyping.com/Adminconsole/api/deletecustomerbyid?id=" +
              item.id
          );

          if (response.data.errorCode === 2) {
            Swal.fire({
              icon: "error",
              text: response.data.Message
            });
            return;
          }

          if (response.data.errorCode === 0) {
            Swal.fire({
              icon: "success",
              text: "Customer Deleted Successfully",
              timer: 1500,
              showConfirmButton: false,
              width: 320,
              padding: "1em",
              confirmButtonText: "OK",
              customClass: {
                popup: "rounded-xl text-sm"
              }
            });

            fetCustomers();
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            text: "Something went wrong while deleting."
          });
        }
      }
    });
  };

  const tamilNaduCities = [
    "Chennai",
    "Coimbatore",
    "Madurai",
    "Tiruchirappalli",
    "Salem",
    "Tirunelveli",
    "Erode",
    "Vellore",
    "Thoothukudi",
    "Dindigul",
    "Thanjavur",
    "Ranipet",
    "Sivakasi",
    "Karur",
    "Udhagamandalam",
    "Hosur",
    "Nagercoil",
    "Kanchipuram",
    "Kumarapalayam",
    "Karaikudi",
    "Neyveli",
    "Cuddalore",
    "Kumbakonam",
    "Tiruvannamalai",
    "Pollachi",
    "Rajapalayam",
    "Gudiyatham",
    "Pudukkottai",
    "Vaniyambadi",
    "Ambur",
    "Nagapattinam",
    "Viluppuram",
    "Tiruppur",
    "Ariyalur",
    "Perambalur",
    "Krishnagiri",
    "Dharmapuri",
    "Namakkal",
    "Tenkasi"
  ];

  const cityOptions = tamilNaduCities.map((city) => ({
    label: city,
    value: city
  }));

  const handleGo = (id, customername, type) => {
    console.log(
      "My id is:",
      id,
      "Customer name:",
      customername,
      "Customer type:",
      type
    );
    navigate("/pricing", {
      state: { id: id, customername: customername, type: type }
    });
  };

  return (
    <div className="p-6 space-y-6 bg-gray-50 min-h-screen">
      {/* ===== Header Section ===== */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">Customers</h2>
          <p className="text-sm text-gray-500">Manage your Customers</p>
        </div>

        <button
          onClick={() => {
            resetForm(); // clear old edit data
            setShowModal(true);
          }}
          className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 transition text-white px-4 py-2 rounded-lg shadow-sm"
        >
          <Plus size={18} />
          Add Customer
        </button>
      </div>

      {/* ===== Search + Info Bar ===== */}
      <div className="flex justify-between items-center">
        <div className="relative">
          <Search size={16} className="absolute left-3 top-3 text-gray-400" />
          <input
            type="text"
            placeholder="Search customer..."
            className="pl-9 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none bg-white shadow-sm"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <span className="text-sm text-gray-500">
          Total: {customerlist.length} Customers
        </span>
      </div>

      {/* ===== Table ===== */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-100 text-gray-600 uppercase text-xs tracking-wider">
            <tr>
              <th className="p-4 text-left">Customer Name</th>
              <th className="p-4 text-left">Mobile Number</th>
              <th className="p-4 text-left">Customer Type</th>
              <th className="p-4 text-left">GSTIN</th>
              <th className="p-4 text-left">City</th>
              <th className="p-4 text-left">State</th>
              <th className="p-4 text-left">Email</th>
              <th className="p-4 text-left">Address</th>
              <th className="p-4 text-left">Geo Location</th>
              <th className="p-4 text-left">Website</th>
              <th className="p-4 text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {customerlist.map((item) => (
              <tr
                key={item.id}
                className="border-t hover:bg-gray-50 transition"
              >
                <td className="p-4 font-medium text-gray-700">
                  {item.customername}
                </td>

                <td className="p-4 text-gray-600">{item.mobilenumber}</td>
                <td className="p-4">
                  <button
                    onClick={() =>
                      handleGo(item.id, item.customername, item.type)
                    }
                    className="text-blue-600 hover:text-blue-800 hover:underline transition cursor-pointer"
                  >
                    {item.type}
                  </button>
                </td>
                <td className="p-4 text-gray-600">{item.gstin}</td>
                <td className="p-4 text-gray-600">{item.city}</td>
                <td className="p-4 text-gray-600">{item.state}</td>
                <td className="p-4 text-gray-600">{item.email}</td>
                <td className="p-4 text-gray-600">{item.address}</td>
                <td className="p-4 text-gray-600">{item.gelocation}</td>
                <td className="p-4 text-gray-600">{item.website}</td>

                <td className="p-4 flex justify-center gap-4">
                  <button
                    className="text-blue-600 hover:text-blue-800 transition"
                    onClick={() => onEdit(item)}
                  >
                    <Pencil size={18} />
                  </button>

                  <button
                    className="text-red-500 hover:text-red-700 transition"
                    onClick={() => onDelete(item)}
                  >
                    <Trash2 size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* ===== Pagination Footer ===== */}
        <div className="flex justify-between items-center p-4 border-t bg-gray-50">
          <span className="text-sm text-gray-500">
            Showing 1 to {customerlist.length} of {customerlist.length} entries
          </span>

          <div className="flex gap-2">
            <button className="px-3 py-1 border rounded-md text-sm hover:bg-gray-100">
              Previous
            </button>
            <button className="px-3 py-1 bg-blue-600 text-white rounded-md text-sm">
              1
            </button>
            <button className="px-3 py-1 border rounded-md text-sm hover:bg-gray-100">
              Next
            </button>
          </div>
        </div>
      </div>

      {/* ===== Modal ===== */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-2xl w-96 space-y-4 shadow-xl">
            <h3 className="text-lg font-semibold text-gray-800">
              {isEditMode ? "Edit Customer" : "Add Customer"}
            </h3>

            <input
              placeholder="Customer Name *"
              type="text"
              className="border w-full px-3 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              value={customername}
              onChange={(e) => setCustomername(e.target.value)}
            />

            <input
              placeholder="Mobile Number *"
              type="number"
              className="border w-full px-3 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              value={mobilenumber}
              onChange={(e) => setMobilenumber(e.target.value)}
            />

            <Select
              options={customerTypeOptions}
              value={customerTypeOptions.find(
                (option) => option.value === customertype
              )}
              onChange={(selectedOption) =>
                setCustomertype(selectedOption ? selectedOption.value : "")
              }
              placeholder="Select Customer Type *"
              isSearchable={false}
              className="text-sm"
            />

            <input
              placeholder="GSTIN "
              type="text"
              className="border w-full px-3 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              value={gstin}
              onChange={(e) => setGstin(e.target.value)}
            />

            <Select
              options={cityOptions}
              value={cityOptions.find((option) => option.value === city)}
              onChange={(selectedOption) =>
                setCity(selectedOption ? selectedOption.value : "")
              }
              placeholder="Select City *"
              isSearchable
              className="text-sm"
            />

            <input
              placeholder="State *"
              type="text"
              disabled
              className="border w-full px-3 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              value={state}
              onChange={(e) => setState(e.target.value)}
            />

            <input
              placeholder="Email "
              type="email"
              className="border w-full px-3 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <input
              placeholder="Address *"
              type="text"
              className="border w-full px-3 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />

            <input
              placeholder="Geo Location "
              type="text"
              className="border w-full px-3 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              value={gelocation}
              onChange={(e) => setGeolocation(e.target.value)}
            />

            <input
              placeholder="Website "
              type="text"
              className="border w-full px-3 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
            />

            <div className="flex justify-end gap-3 pt-2">
              <button
                onClick={() => {
                  setShowModal(false);
                  resetForm();
                }}
                className="px-4 py-2 text-gray-600 hover:text-black"
              >
                Cancel
              </button>

              <button
                onClick={handleSubmit}
                disabled={loading}
                className={`px-4 py-2 rounded-lg text-white transition ${
                  loading
                    ? "bg-green-400 cursor-not-allowed"
                    : "bg-green-600 hover:bg-green-700"
                }`}
              >
                {loading ? "Saving..." : isEditMode ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
